import spinner from './assets/spinner.gif'
function Spinner() {
  return (
    <div>
      <img src={spinner} alt='loading' />
    </div>
  )
}

export default Spinner
